import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import './LoginPage.css';

const RegisterPage = () => {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [fields, setFields] = useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: ''
    });
    const [touched, setTouched] = useState({});

    const validations = {
        name: (v) => {
            if (!v) return 'O nome é obrigatório.';
            if (v.length < 3) return 'O nome deve ter no mínimo 3 caracteres.';
            if (v.length > 100) return 'O nome deve ter no máximo 100 caracteres.';
            return null;
        },
        email: (v) => {
            if (!v) return 'O e-mail é obrigatório.';
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return 'E-mail inválido.';
            return null;
        },
        password: (v) => {
            if (!v) return 'A senha é obrigatória.';
            return null;
        },
        confirmPassword: (v) => {
            if (!v) return 'Confirme sua senha.';
            if (v !== fields.password) return 'As senhas não coincidem.';
            return null;
        }
    };

    const errors = {
        name: validations.name(fields.name),
        email: validations.email(fields.email),
        password: validations.password(fields.password),
        confirmPassword: validations.confirmPassword(fields.confirmPassword)
    };

    const isFormValid = Object.values(errors).every(e => e === null);

    const handleChange = (e) => {
        setFields(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleBlur = (e) => {
        setTouched(prev => ({ ...prev, [e.target.name]: true }));
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            await register(fields.name, fields.email, fields.password);
            navigate('/app');
        } catch {
            setError('Erro ao criar conta. Tente novamente.');
        }
    };

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="login-logo">
                    <div className="login-logo-icon">NWK</div>
                    <span className="login-logo-text">NewWeekKanban</span>
                </div>

                <h1 className="login-title">Criar conta</h1>
                <p className="login-subtitle">Preencha os dados para se registrar</p>

                {error && <div className="login-error">{error}</div>}

                <form className="login-form" onSubmit={handleRegister}>
                    <div className="login-field">
                        <label>Nome</label>
                        <input
                            name="name"
                            type="text"
                            placeholder="Seu nome"
                            value={fields.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        {touched.name && errors.name &&
                            <span className="login-field-error">{errors.name}</span>
                        }
                    </div>
                    <div className="login-field">
                        <label>E-mail</label>
                        <input
                            name="email"
                            type="email"
                            placeholder="seu@email.com"
                            value={fields.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        {touched.email && errors.email &&
                            <span className="login-field-error">{errors.email}</span>
                        }
                    </div>
                    <div className="login-field">
                        <label>Senha</label>
                        <input
                            name="password"
                            type="password"
                            placeholder="••••••••"
                            value={fields.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        {touched.password && errors.password &&
                            <span className="login-field-error">{errors.password}</span>
                        }
                    </div>
                    <div className="login-field">
                        <label>Confirmar senha</label>
                        <input
                            name="confirmPassword"
                            type="password"
                            placeholder="••••••••"
                            value={fields.confirmPassword}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        {touched.confirmPassword && errors.confirmPassword &&
                            <span className="login-field-error">{errors.confirmPassword}</span>
                        }
                    </div>
                    <button
                        type="submit"
                        className="login-btn"
                        disabled={!isFormValid}
                    >
                        Criar conta
                    </button>
                </form>

                <div className="login-footer">
                    Já tem uma conta? <Link to="/login">Entrar</Link>
                </div>
            </div>
        </div>
    );
};

export default RegisterPage;